export function isRegionOnCurrentIaLayer (get, region) {
  const inputLayer = get('IA_ANNOTATIONS/iaInputLayer');
  return inputLayer && region.layerId === inputLayer.id;
}



// WEBPACK FOOTER //
// ./src/shared/stores/image-analysis/helpers.js